import initClientSentry from '@autobid/sentry/src/client.config'

initClientSentry()
